
import { defineComponent, PropType } from "vue";
import store from "@/store";
import CompetencyPeriodAssignmentsService from "@/api/AcademicBase/CompetencyPeriodAssignmentsService";
import PeriodsService from "@/api/Configuration/PeriodsService";
import type {
    ICompetencyPeriodAssignmentsModel,
    IPeriodsModel
} from "@/interfaces/modules";


export default defineComponent({
    name: "CompetencyPeriodAssignmentsTab",
    props: {
        competencyId: {
            type: Number as PropType<number>,
            required: true,
        },
    },
    data() {
        return {
            saving: false,
            periods: [] as IPeriodsModel[],
            form: {
                dialog: false,
                loading: false,
                record: {} as ICompetencyPeriodAssignmentsModel,
            },
            table: {
                filters: { search: "" },
                currentPage: 1,
                loading: false,
                headers: [
                    { key: "PeriodId", label: "Período", sortable: true },
                    { key: "WeightPercent", label: "Peso %", sortable: true },
                    { key: "AssignedAt", label: "Fecha asignación", sortable: true },
                    { key: "CreatedByFormat", label: "Creación", sortable: true },
                    { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
                    { key: "action", label: "Acciones", sortable: false },
                ],
                records: [] as ICompetencyPeriodAssignmentsModel[],
                rowsPerPage: 10,
            } as any,
        };
    },
    async mounted() {
        await this.load();
    },
    watch: {
        competencyId: {
            immediate: false,
            async handler() {
                await this.load();
            },
        },
    },
    computed: {
        filteredItems(): any {
            const q = this.table.filters.search?.toLowerCase() || "";
            return q
                ? this.table.records.filter((item: ICompetencyPeriodAssignmentsModel) =>
                    [item.PeriodName, item.PeriodId, item.WeightPercent]
                        .filter(Boolean)
                        .some((v) => String(v).toLowerCase().includes(q))
                )
                : this.table.records;
        },
        rows(): number {
            return this.table.records?.length || 0;
        },
    },
    methods: {
        async load() {
            if (!this.competencyId) return;
            this.form.loading = true;
            try {
                // Ajusta al método real
                this.periods = await PeriodsService.GetPeriods();
                this.table.records = await CompetencyPeriodAssignmentsService.GetByCompetencyId(this.competencyId as any) || [];
            } finally {
                this.form.loading = false;
            }
        },
        openModal() {
            this.form.record = {
                Id: 0,
                CompetencyId: this.competencyId,
                PeriodId: 0,
                WeightPercent: 0,
                AssignedAt: new Date().toISOString().substring(0, 10),
            } as ICompetencyPeriodAssignmentsModel;
            this.form.dialog = true;
        },
        async edit(data: ICompetencyPeriodAssignmentsModel) {
            this.form.record = await CompetencyPeriodAssignmentsService.GetById(data.Id);
            this.form.dialog = true;
        },
        async handleSubmit(event: Event) {
            event.preventDefault();

            this.saving = true;
            try {
                await CompetencyPeriodAssignmentsService.Post(
                    this.form.record as ICompetencyPeriodAssignmentsModel
                );
                this.form.dialog = false;
                this.saving = false;
                store.dispatch("core/popupDialog", {
                    text: "Registro completado con éxito.",
                    type: "success",
                    showCancelButton: false,
                });

                await this.load();
            } catch (err: any) {
                this.form.loading = false;
                this.saving = false;
                store.dispatch("core/popupDialog", {
                    text: `Error: ${err?.response?.data?.message || err?.message}`,
                    type: "error",
                    showCancelButton: false,
                });
            }

        },
    },
});
